const delivery = {
    name:'快递服务',
    code: '',
    children: [
        {
            name: '时效-快速',
            code: '',
            children: [
                {
                    name: '顺丰即日',
                    code: 'SE0002',
                },
                {
                    name: '顺丰次晨',
                    code: 'SE0003',
                },
                {
                    name: '顺丰标快',
                    code: 'SE0001',
                },
            ]
        },
        {
            name: '经济-实惠',
            code: '',
            children: [
                {
                    name: '顺丰特惠',
                    code: 'SE0004',
                },
            ]
        }             
    ]  
}
const ship = {
    name: '快运服务',
    code: '',
    children: [
        {
            name: '重货包裹',
            code: 'SE0100'
        },
        {
            name: '小票零担',
            code: 'SE0101'
        },
        {
            name: '大票零担',
            code: 'SE0114'
        },
        {
            name: '重货专运',
            code: 'SE0020'
        },
    ],
}
const intlService = { 
    name: '国际服务',
    children: [
        {
            name: '国际标快',
            code: 'SE0051'
        },
        {
            name: '国际特惠',
            code: 'SE0005'
        },
        {
            name: '国际小包',
            code: 'SE0032'
        },
        {
            name: '国际电商专递',
            code: 'SE0054'
        },
        {
            name: '国际重货',
            code: 'SE0079'
        },
        {
            name: '海购丰运',
            code: 'SE0011'
        },
        {
            name: '海外仓储',
            code: 'SE0111'
        },
    ],
}

const solution = {
    name: '解决方案',
    code: '',
    children: [
        {
            name: '冷运服务',
            children: [
                {
                    name: '冷仓速配',
                    code: 'SE0112',
                },
                {
                    name: '冷运特惠',
                    code: 'SE0113',
                },
                {
                    name: '冷运到店',
                    code: 'SE0059',
                },
                {
                    name: '冷运零担',
                    code: 'SE0030',
                },
                {
                    name: '冷运专车',
                    code: 'SE0031',
                },
                {
                    name: '冷运仓储',
                    code: 'SE0038',
                },
            ]
        },
        {
            name: '医药服务',
            children: [
                {
                    name: '医药安心递',
                    code: 'SE0099',
                },
                {
                    name: '医药专递',
                    code: 'SE0024',
                },
                {
                    name: '医药零担',
                    code: 'SE0075',
                },
                {
                    name: '医药专车',
                    code: 'SE0076',
                },
                {
                    name: '医药仓储',
                    code: 'SE0077',
                },
            ]
        }
    ]
}
const ExpressRouter = {
    name: '快递产品',
    code: '',
    children: [
        delivery,
        ship,
        intlService,
        solution
    ]
}

export default ExpressRouter


// WEBPACK FOOTER //
// ./src/components/header/menuConfig/express.js